module.exports = __webpack_public_path__ + "assets/f30cc80334b071a77d58bf00b3516701.ttf";